module.exports = __webpack_public_path__ + "img/midimg.dd0c0dff.png";